import Dispatch from "nexia_mobile/flux_like/dispatch";
import Store, { setValueAtPath } from "nexia_mobile/flux_like/store";
import Device from "nexia_mobile/models/device";
import Automation from "nexia_mobile/models/automation";
import { clearHistoryAndPush } from "nexia_mobile/history";

Dispatch.on("POPULATE_SESSION", () => {
  Dispatch("DISABLE_LOCATION_POLLING");
  Store.session.populate().then(() => {
    Dispatch("ENABLE_LOCATION_POLLING");
    Dispatch("SESSION_POPULATED");
  });
});

Dispatch.on("FAST_POPULATE_SESSION", () => {
  Store.session.populate();
});

Dispatch.on("SESSION_POPULATED", () => {
  if (Store.appState.inDemoMode) {
    return;
  }

  Dispatch("PUBLISH_SETTINGS_TO_SERVER");
  Dispatch("OBTAIN_PUSH_NOTIFICATION_TOKEN");
  Dispatch("SHOW_NEWS_FROM_STARTUP");
  Dispatch("SHOW_CHOICES");
});

Dispatch.on("SHOW_CHOICES", () => {
  setValueAtPath("forceChoiceDialogOpen", true);
});

const addDemoModeEventToStore = (event, model) => {
  const matches = model.get("id").match(/\d+$/);
  if (matches == null) {
    // The model url doesn't match the expected format (ending with a number);
    // don't try to add an event for it.
    return;
  }
  const id = matches[0];

  let filter = "_NO_FILTER_";
  if (model instanceof Device) {
    filter = `device_id=${id}`;
  } else if (model instanceof Automation) {
    filter = `automation_id=${id}`;
  }

  const newEvents = {
    ...Store.demoModeEvents,
    _NO_FILTER_: [
      // All events go into the 'no filter' array
      event,
      ...(Store.demoModeEvents._NO_FILTER_ || []),
    ],
  };

  if (filter !== "_NO_FILTER_") {
    newEvents[filter] = [event, ...(Store.demoModeEvents[filter] || [])];
  }

  setValueAtPath("demoModeEvents", newEvents);
};

Dispatch.on("PARSED_DEMO_MODE_EVENT", (event, model) => {
  addDemoModeEventToStore(event, model);
});

Dispatch.on(
  "DEMO_MODE_EVENT",
  (
    model,
    description,
    user = "Demo User",
    occurredAt = new Date().toISOString()
  ) => {
    if (!Store.appState.inDemoMode) {
      return;
    }

    const event = {
      /* eslint-disable camelcase */
      device_name: model.get("name"),
      user_name: user,
      description,
      occurred_at: occurredAt,
      /* eslint-enable camelcase */
    };

    // We have to keep all the events in the Store instead of relying on the ones
    // in the Location's events collection and the Device/Automation's events
    // collection because when you change the filter on the "Events" page, it
    // actually mutates the events in the collection. This works out in the real
    // world where we fetch events every time that page is shown (thereby filling
    // the collection up with the right events again), because the events are in
    // the serverside database. But in demo mode, there's no serverside database,
    // so the Store is our stand-in.
    addDemoModeEventToStore(event, model);
  }
);

const handleReturnToDashboard = () => {
  if (Store.session.hasMultipleLocations()) {
    Store.appState.resetCurrentLocation();
  }
  clearHistoryAndPush("/app/home");
};

const newPromiseRefreshSession = (handlerToDashboard) => {
  const devices = Store.session
    .get("locations")
    .first()
    .get("devices");

  return new Promise((resolve) => {
    Store.session.populate().then(() => {
      const finishRefresh = _.once(() => {
        resolve();
        if (handlerToDashboard) {
          handlerToDashboard();
        }
      });

      // The response is parsed asynchronously, wait until devices actually update.
      devices.once("update", finishRefresh);
      // but if they never do, still hide the spinner 10 seconds after the fetch finishes
      setTimeout(finishRefresh, 10000);
    });
  });
};

let returnToDashboardPromise = Promise.resolve();

Dispatch.on("REFRESH_SESSION_AND_RETURN_TO_DASHBOARD", () => {
  if (!Store.appState && !Store.appState.currentLocation) {
    return;
  }

  returnToDashboardPromise = newPromiseRefreshSession(handleReturnToDashboard);
});

// TODO: Better answer for async actions (probably won't have it until we're using redux)
export function getPendingPromiseForRefreshSessionAndReturnToDashboard() {
  return returnToDashboardPromise;
}



// WEBPACK FOOTER //
// ./src/flux_like/action_handlers/session.js